import React from 'react';
import { useSelector } from 'react-redux';
import { isAfterOrEqual } from '@Utils/versionUtils';
import Permission from '@Constants/permissions';
import { isAuthorized, canNavTOScoreCard } from '@Service/authentication';

export const PermissionsContext = React.createContext(null);

export function PermissionsProvider(props) {
    const version = useSelector(state => state.auth?.version);

    const user = useSelector(state => state.auth?.user);

    const haveAccessToScorecardsPage = canNavTOScoreCard();

    const haveAccessToClausesPage =
        isAuthorized(user, [Permission.CLAUSE_READ]) && isAfterOrEqual('5.3.0', version);

    const haveAccessToContractsPage =
        user &&
        user.permissions &&
        isAuthorized(user, [Permission.CONTRACT_DOWNLOAD]) &&
        isAfterOrEqual('5.1.0', version);

    const value = {
        haveAccessToScorecardsPage,
        haveAccessToClausesPage,
        haveAccessToContractsPage
    };

    return <PermissionsContext.Provider value={value} {...props} />;
}

export function usePermissions() {
    const context = React.useContext(PermissionsContext);
    if (!context) {
        throw new Error('usePermissions must be used within a PermissionsProvider');
    }
    return context;
}
